import { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import { standardCheckoutRoutes } from "@jti/fe-common";
import { useSelector } from "@jti/store/reduxHooks";
import { useTranslations } from "@jti/ui";

import { CheckoutAside } from "@checkout/components/CheckoutAside";
import { CheckoutProgressGtmObserver } from "@checkout/components/CheckoutProgressGtmObserver";
import { HeaderWithBreadcrumbs } from "@checkout/components/HeaderWithBreadcrumbs";
import { CheckOutSteps } from "@checkout/constants/checkout-constants";
import { useFreeTrial } from "@checkout/hooks/useFreeTrial";
import { useRedirectToTrialProductsFromTrialCheckout } from "@checkout/hooks/useRedirectToTrialProductsFromTrialCheckout";
import { PageBaseLayout } from "@checkout/layouts/PageBaseLayout";

import { ShippingPageContent } from "./components/ShippingPageContent";

export const ShippingPage = () => {
  useRedirectToTrialProductsFromTrialCheckout();
  const history = useHistory();
  const standardCheckoutForm = useSelector((state) => state.standardCheckoutForm);

  const asideSubmitButtonWrapperRef = useRef<HTMLDivElement>(null);

  const { __ } = useTranslations();
  const { isFreeTrial } = useFreeTrial();

  useEffect(() => {
    if (!isFreeTrial && !standardCheckoutForm.isReady) {
      history.replace(standardCheckoutRoutes.root);
    }
  }, [standardCheckoutForm.isReady, isFreeTrial]);

  return (
    <>
      <CheckoutProgressGtmObserver step={CheckOutSteps.Shipping} />

      <PageBaseLayout
        header={
          <HeaderWithBreadcrumbs
            title={__(isFreeTrial ? "cart.title.freeTrial" : "cart.title.checkout")}
            step={CheckOutSteps.Shipping}
          />
        }
        content={<ShippingPageContent asideSubmitButtonWrapperRef={asideSubmitButtonWrapperRef} />}
        aside={<CheckoutAside submitButtonWrapperRef={asideSubmitButtonWrapperRef} step={CheckOutSteps.Shipping} />}
      />
    </>
  );
};
